import { getMessageFactory } from "../getCaxaWebSocket.js";
const createOrderFileTask = getMessageFactory({
  code: "CREATE_ORDER_FILE_TASK"
});
export { createOrderFileTask };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/external/caxa/directive/createOrderFileTask.js